export default "__VITE_ASSET__DNAoCAs0__"